import { useUserQuery } from '@/api/queries/user/useUserQuery';
import type { Network } from '@/features/social-networks/type';
import { computed, type ComputedRef } from 'vue';

export function useSocials() {
  const { user, publicUrl } = useUserQuery();
  const socials = computed(() => user.value?.socials);

  const socialNetworks: ComputedRef<Network[]> = computed(() => {
    return [
      {
        name: 'fb',
        link: socials.value?.fb ?? undefined,
        icon: 'fab fa-facebook-f',
        color: 'facebook',
        label: 'candidate_profile.social_networks.facebook',
      },
      {
        name: 'li',
        link: socials.value?.li ?? undefined,
        icon: 'fab fa-linkedin-in',
        color: 'linkedin',
        label: 'candidate_profile.social_networks.linkedin',
      },
      {
        name: 'twitter',
        link: socials.value?.twitter ?? undefined,
        icon: 'fab fa-square-x-twitter',
        color: 'black',
        label: 'candidate_profile.social_networks.twitter',
      },
      {
        name: 'insta',
        link: socials.value?.insta ?? undefined,
        icon: 'fab fa-instagram',
        color: 'instagram',
        label: 'candidate_profile.social_networks.instagram',
      },
      {
        name: 'perso',
        link: socials.value?.perso ?? undefined,
        icon: 'fas fa-globe',
        color: 'tertiary',
        label: 'candidate_profile.social_networks.website',
      },
    ];
  });

  const socialsShare = computed(() => {
    return [
      {
        name: 'linkedin',
        link: `https://www.linkedin.com/shareArticle?mini=true&url=${publicUrl.value}`,
        icon: 'fab fa-linkedin-in',
        color: 'linkedin',
      },
    ];
  });

  const linkedinShare = computed(() => {
    return {
      name: 'linkedin',
      link: `https://www.linkedin.com/shareArticle?mini=true&url=${publicUrl.value}`,
      icon: 'fab fa-linkedin-in',
      color: 'linkedin',
    };
  });

  return { socialNetworks, socialsShare, linkedinShare };
}
